'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = require('stampy/lib/component/Button');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/Button.js
// module id = 108
// module chunks = 35783957827783 114276838955818 162898551421021